import React, { useEffect, useState } from 'react';
import { Icon } from '../ui/Icon';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-black border-t-2 border-orange-500 shadow-2xl transform transition-transform duration-300" data-id="element-210">
      <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-211">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-212">
          <div className="text-center sm:text-left" data-id="element-213">
            <div className="text-orange-400 font-bold text-lg mb-1" data-id="element-214">
              Promo de Navidad — Solo $497
            </div>
            <div className="text-gray-300 text-sm" data-id="element-215">
              Acceso completo al Bootcamp + Bonos
            </div>
          </div>

          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/xGRln" className="flex-1 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white px-6 py-3 rounded-full font-bold hover:shadow-lg hover:shadow-orange-500/50 transition-all duration-300 hover:scale-105 text-center" data-id="element-216">
            ¡ACCESO INMEDIATO!
          </a>
        </div>
      </div>
    </div>;
}